import { APPLICATION_URL } from "app/views/apply/Apply";

let faqQuestions = [
  {
    question: "What is ZotHacks?",
    answer:
      "ZotHacks is a hackathon event where the only thing limiting what you build is your own creativity – we'll provide the rest. We give you the resources, training, mentorship, and food you need in order for you to build a full web application with a team."
  },
  {
    question: "What should I bring?",
    answer:
      "Due to current circumstances regarding the COVID-19 pandemic, ZotHacks will be in-person with protective safety measures. For this year's iteration, please bring a positive attitude, a device to connect and collaborate with your team, and a willingness to try new technologies! Additional recommended items are: your device’s charger, a clean face covering, a refillable water bottle, earphones, any desired peripherals, and some scratch paper for whiteboarding."
  },
  {
    question: "How will team formations work for admitted students?",
    answer:
      "Teams will be up to 4 people. Don’t worry if you do not have teammates going into ZotHacks because we will be helping with team formations prior to the event. If you are accepted, you will also have the chance to request team members, but they are not guaranteed."
  },
  {
    question:
      "What if I have no prior experience in programming, coding, or hackathons?",
    answer:
      "We don’t expect hackers to have any prior experience. We will be providing starter packs, workshops, and mentors to help new hackers get started on projects and learn new technologies."
  },
  {
    question: "Who should attend?",
    answer:
      "If you do not know much or anything about web development but are interested in learning how to build web apps, you are the ideal candidate for ZotHacks. This year, we would like only first and second years of UCI to be attendees; for those who are transfers or third years and up, consider applying to be a mentor!"
  },
  {
    question: "Do I sign up as a team or individual?",
    answer:
      `You will <a href=${APPLICATION_URL} target='_blank' >apply</a> as an individual. We will be personally reviewing each application and accepting on an individual basis.`,
  },
  {
    question: "Will there be prizes?",
    answer:
        "There will be prizes for all winners at ZotHacks 2022.",
  },
  {
    question:
      "Am I allowed to come with a project pre-built or will I be building the project from scratch?",
    answer:
      "You will be building projects from scratch, although we will be offering starter packs to help you get started. You are encouraged to come with ideas of what you want to build. All pre-built projects will be disqualified.\n"
  },
  {
    question: "What platform will you be using to host ZotHacks?",
    answer:
      "Currently, ZotHacks will be using Slack as our main source of communication. Expect announcements, mentor support, and memes to be discussed here! "
  },
  // {
  //   question:
  //     "How do you plan to keep the sense of community in an online event?",
  //   answer:
  //     "As mentioned before, with the following online platforms, we are going to leverage our virtual event's tooling to facilitate networking with hackers, mentors, and sponsors! Additionally, we are looking to keep the spirit of the hackathon alive via numerous virtual-friendly events and workshops. Each group of hackers will also be assigned a mentor to assist with any issues that happen while developing your projects.",
  // },
]

export { faqQuestions }
